// extracted by mini-css-extract-plugin
module.exports = {"badge":"Navigation_badge__2otnx","header":"Navigation_header__2k7to","active":"Navigation_active__xx_4q","logo":"Navigation_logo__2DMrO"};